import { fetchOrganizations } from 'admin/actions/organization';
import { fetchShops } from 'admin/actions/shops';
import { isEmptyObj } from 'admin/utils';
import { useEffect, useState } from 'react';

const useShopSelector = ({ money, organization }) => {
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [shopOptions, setShopOptions] = useState([]);

  const toOption = (value) => (value && !isEmptyObj(value) ? { label: value.name, value } : null);

  useEffect(() => {
    const refetchOrganizations = () => {
      const query = `private_money_id=${money.id}&per_page=10000`;
      fetchOrganizations(query)
        .then((members) => {
          const issuer = money.organization;
          const ops = members.rows.map(toOption);
          ops.push({ label: issuer.name, value: issuer });
          setOrganizationOptions(ops);
        })
        .catch(() => {
          const ops = [{ label: money.organization.name, value: money.organization }];
          setOrganizationOptions(ops);
        });
    };

    if (!isEmptyObj(money)) {
      setOrganizationOptions([]);
      setShopOptions([]);
      refetchOrganizations();
    }
  }, [money]);

  useEffect(() => {
    const refetchShops = () => {
      const query = `organization_code=${organization.code}&private_money_id=${money.id}`;
      fetchShops(query).then((shops) => {
        const ops = shops.map(toOption);
        setShopOptions(ops);
      });
    };

    if (!isEmptyObj(money) && !isEmptyObj(organization)) {
      setShopOptions([]);

      refetchShops();
    }
  }, [money, organization]);

  return [organizationOptions, shopOptions];
};

export default useShopSelector;
